<template>
  <div class="CartSubscriptionItem">
    <div class="CartSubscriptionItem-info">
      <p class="CartSubscriptionItem-label">
        <span v-if="quantity">({{ quantity }}x)</span>
        {{ label }}
      </p>

      <p v-if="description" class="CartSubscriptionItem-description">
        {{ description }}
      </p>
    </div>

    <div class="CartSubscriptionItem-pricing">
      <p class="CartSubscriptionItem-value">
        <s v-if="originalValue" class="CartSubscriptionItem-originalValue">{{ originalValue }}</s>
        <span class="CartSubscriptionItem-currentValue">{{ value }}</span>
      </p>

      <Tag
        v-if="tag"
        type="warning"
        variant="filled"
        size="xs"
        leftIcon="brightness-percent"
      >
        {{ tag }}
      </Tag>
    </div>
  </div>
</template>

<script setup lang="ts">
import Tag from '../../atoms/Tag/Tag.vue';

export interface CartSubscriptionItemProps {
  label: string;
  value: string;
  originalValue?: string;
  tag?: string;
  description?: string;
  quantity?: number | null;
}

defineProps<CartSubscriptionItemProps>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/layout';
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .CartSubscriptionItem {
    display: flex;
    justify-content: space-between;
    gap: vars.$dimensions-d-5;

    &-info {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-1;
    }

    &-pricing {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: vars.$dimensions-d-1;
    }

    &-label,
    &-value {
      color: vars.$organisms-cart-cart-primary-text-color;
      @include text.text(sm);
    }

    &-value {
      font-weight: vars.$typography-weight-strong;
      text-align: end;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: baseline;
      gap: 0 vars.$dimensions-d-2;
    }

    &-originalValue,
    &-currentValue {
      white-space: nowrap;
    }

    &-originalValue {
      color: vars.$organisms-cart-cart-secondary-text-color;
      font-weight: vars.$typography-weight-body;
    }

    &-description {
      color: vars.$organisms-cart-cart-secondary-text-color;
      @include text.text(xs);
    }
  }
}
</style>
